import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {AppStateService} from "../providers/app-state.service";
import {environment} from "../../environments/environment";
import {VetDoctorVetVisitTypeDgSearchResults} from "../models/datagrid-search-results/vet-doctor-vet-visit-type.dg-search-results.model";
import {VetDoctorVetVisitTypeService} from "../providers/vet-doctor-vet-visit-type.service";

@Injectable()
export class VetDoctorVetVisitTypeResolve implements Resolve<VetDoctorVetVisitTypeDgSearchResults> {
  constructor(private vetDoctorVetVisitTypeService: VetDoctorVetVisitTypeService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<VetDoctorVetVisitTypeDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.vetDoctorVetVisitTypeService.getResults(environment.DEFAULT_RESULTS_LIMIT, 0, 'ASC', 'created', false).pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
